import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The row menu — the house's one disclosure.
 *
 * A "…" trigger and a popover. It is the ordered scene row's menu and the piece card's,
 * which is why it lives here rather than on either.
 *
 * React Aria's `MenuTrigger` / `Popover` / `Menu` own all of it now: opening, Escape, the
 * click outside, arrow keys and typeahead between items, the focus that returns to the
 * trigger when it closes, and placement that flips rather than running off the edge of a
 * card. The hand-rolled document listeners are gone.
 *
 * The destructive item is `tone: 'remove'` — brick text, no fill: this menu never holds an
 * irreversible action, only archive, which is reversible at one tap. Permanent delete lives
 * behind a danger dialog in the archive, and nowhere else (PRD 04 §9).
 */
import { Fragment } from 'react';
import { Button as AriaButton, Menu, MenuItem, MenuTrigger, Popover, Separator, } from 'react-aria-components';
import { DotsGlyph } from '../glyphs.js';
export function RowMenu({ label, items }) {
    return (_jsxs(MenuTrigger, { children: [_jsx("div", { className: "sr-menu", children: _jsx(AriaButton, { className: "sr-more", "aria-label": label, children: _jsx(DotsGlyph, {}) }) }), _jsx(Popover, { className: "sr-pop", placement: "bottom end", offset: 6, children: _jsx(Menu, { "aria-label": label, className: "menu-list", children: items.map((item) => (_jsxs(Fragment, { children: [item.separated === true && _jsx(Separator, { className: "menu-sep" }), _jsx(MenuItem, { id: item.key, className: item.tone === 'remove' ? 'menu-item is-remove' : 'menu-item', onAction: item.onSelect, children: item.label })] }, item.key))) }) })] }));
}
//# sourceMappingURL=RowMenu.js.map